import styles from './ContentHeader.module.scss';

interface ContentHeaderProps {
    onMenuToggle: () => void;
    onThemeToggle?: () => void;
    isDarkTheme?: boolean;
}

export function ContentHeader({ onMenuToggle, onThemeToggle, isDarkTheme }: ContentHeaderProps) {
    return (
        <header className={styles.header}>
            <button className={styles.menuButton} onClick={onMenuToggle} aria-label="Toggle menu">
                <span className={styles.hamburger}>
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </button>

            <div className={styles.spacer} />

            <div className={styles.actions}>
                {onThemeToggle && (
                    <button
                        className={styles.themeButton}
                        onClick={onThemeToggle}
                        aria-label={isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'}
                    >
                        {isDarkTheme ? '☀️' : '🌙'}
                    </button>
                )}
                <div className={styles.avatar}>
                    <span>B</span>
                </div>
            </div>
        </header>
    );
}
